import Check from './Check';

Check.install = function(Vue) {
    Vue.component(Check.name, Check);
};

export default Check;